<div class="input-error" 
	[class.opened]="form.get(field).errors && form.get(field).touched">
	<span class="lnr lnr-warning"></span>
	<p *ngIf="form.get(field).hasError('required')">{{'validations.required' | translate}}</p>
	<p *ngIf="form.get(field).hasError('minlength')">{{'validations.minlength' | translate}}</p>
	<p *ngIf="form.get(field).hasError('maxlength')">{{'validations.maxlength' | translate}}</p>
	<p *ngIf="form.get(field).hasError('email')">{{'validations.no_valid_email' | translate}}</p>
	<p *ngIf="form.get(field).hasError('pattern')">Carácter no válido</p>
</div>